import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formDataRule,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_vm.formData.sign_body_status === _vm.$enum.mine.SignBodyStatusEnum.AUDIT_NOT_PASS ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 14,
      "offset": 6
    }
  }, [_c('a-alert', {
    staticClass: "mb-20",
    attrs: {
      "message": _vm.t('您的主体信息审核不通过，请修改后重新提交'),
      "type": "warning",
      "show-icon": ""
    }
  })], 1)], 1) : _vm._e(), !!_vm.formData.account_code && _vm.formData.sign_business_type_list && _vm.formData.sign_business_type_list.length || !_vm.formData.account_code ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u7B7E\u7EA6\u4E1A\u52A1"),
      "prop": "type",
      "label": _vm.t('签约业务')
    }
  }, [_c('a-checkbox-group', {
    attrs: {
      "disabled": !!_vm.formData.account_code
    },
    model: {
      value: _vm.formData.sign_business_type_list,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "sign_business_type_list", $$v);
      },
      expression: "formData.sign_business_type_list"
    }
  }, _vm._l(_vm.signBusinessTypeEnum, function (item) {
    return _c('a-checkbox', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4E3B\u4F53\u7C7B\u522B"),
      "prop": "type",
      "label": _vm.t('主体类别')
    }
  }, [_c('my-select', {
    model: {
      value: _vm.formData.type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "type", $$v);
      },
      expression: "formData.type"
    }
  }, [_vm._l(_vm.certificationTypeEnum, function (item, index) {
    return [_c('a-select-option', {
      key: index,
      attrs: {
        "value": String(item.value)
      }
    }, [_vm._v(_vm._s(item.text))])];
  })], 2)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u6CE8\u518C\u56FD\u5BB6/\u533A\u57DF"),
      "prop": "register_area_code",
      "label": _vm.t('注册国家/区域')
    }
  }, [_c('my-select', {
    attrs: {
      "show-search": "",
      "size": "large",
      "option-filter-prop": "children"
    },
    on: {
      "change": _vm.handleRegisterAreaCodeChange
    },
    model: {
      value: _vm.formData.register_area_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "register_area_code", $$v);
      },
      expression: "formData.register_area_code"
    }
  }, [_vm._l(_vm.showRegisterCountryList, function (item, index) {
    return [_c('a-select-option', {
      key: index,
      attrs: {
        "value": item.country_code
      }
    }, [_vm._v(_vm._s(item.country_name) + "/" + _vm._s(item.country_code))])];
  })], 2)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u7701/\u5DDE"),
      "prop": "province_id",
      "label": _vm.t('省/州')
    }
  }, [_c('my-select', {
    attrs: {
      "show-search": ""
    },
    on: {
      "change": _vm.handleProvinceCodeChange
    },
    model: {
      value: _vm.formData.province_id,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "province_id", $$v);
      },
      expression: "formData.province_id"
    }
  }, [_vm._l(_vm.provinceList, function (item, index) {
    return [_c('a-select-option', {
      key: index,
      attrs: {
        "value": String(item.id)
      }
    }, [_vm._v(_vm._s(item.name))])];
  })], 2)], 1), _vm.formData.register_area_code === _vm.$enum.mine.RegisterAreaCodeEnum.CN ? _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u57CE\u5E02"),
      "prop": "city_id",
      "label": _vm.t('城市')
    }
  }, [_c('my-select', {
    attrs: {
      "show-search": ""
    },
    on: {
      "change": _vm.handleCityCodeChange
    },
    model: {
      value: _vm.formData.city_id,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "city_id", $$v);
      },
      expression: "formData.city_id"
    }
  }, [_vm._l(_vm.cityList, function (item, index) {
    return [_c('a-select-option', {
      key: index,
      attrs: {
        "value": String(item.id)
      }
    }, [_vm._v(_vm._s(item.name))])];
  })], 2)], 1) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4F01\u4E1A\u540D\u79F0"),
      "prop": "sign_body_name",
      "label": _vm.t('企业名称')
    }
  }, [_c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('用于实名认证和签约合同，请正确填写')
    },
    model: {
      value: _vm.formData.sign_body_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "sign_body_name", $$v);
      },
      expression: "formData.sign_body_name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u589E\u503C\u7A0E\u767B\u8BB0\u53F7"),
      "prop": "credit_code"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.t('增值税登记号')) + " "), _c('a-tooltip', {
    attrs: {
      "overlayStyle": {
        'max-width': '400px'
      },
      "placement": "top"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.t('1、国内公司的增值税号，即统一社会信用代码；')))]), _c('p', [_vm._v(_vm._s(_vm.t('2、国内个人的增值税号，即身份证号；')))]), _c('p', [_vm._v(_vm._s(_vm.t('3、香港公司的增值税号，即登记证编码；')))]), _c('p', [_vm._v(_vm._s(_vm.t('4、海外公司的增值税号，即Tax ID；')))])]), _c('a-icon', {
    attrs: {
      "type": "question-circle"
    }
  })], 2)], 1), _c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "max-length": 20,
      "placeholder": _vm.t('用户实名认证和签约合同，请正确填写')
    },
    model: {
      value: _vm.formData.credit_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "credit_code", $$v);
      },
      expression: "formData.credit_code"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8054\u7CFB\u4EBA"),
      "prop": "contact_name",
      "label": _vm.t('联系人')
    }
  }, [_c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入联系人')
    },
    model: {
      value: _vm.formData.contact_name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "contact_name", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.contact_name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8054\u7CFB\u7535\u8BDD"),
      "prop": "phone_number",
      "label": _vm.t('联系电话')
    }
  }, [_c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入联系电话，与营业执照保持一致')
    },
    model: {
      value: _vm.formData.phone_number,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "phone_number", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.phone_number"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8054\u7CFB\u90AE\u7BB1"),
      "prop": "email",
      "label": _vm.t('联系邮箱')
    }
  }, [_c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入联系邮箱，与营业执照保持一致')
    },
    model: {
      value: _vm.formData.email,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "email", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.email"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8D22\u52A1\u90AE\u7BB1"),
      "prop": "finance_email",
      "label": _vm.t('财务邮箱')
    }
  }, [_c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入财务邮箱，用于接受账单相关信息，请正确填写')
    },
    model: {
      value: _vm.formData.finance_email,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "finance_email", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.finance_email"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8D26\u5355\u6A21\u677F"),
      "prop": "bill_lang_type",
      "label": _vm.t('账单模板')
    }
  }, [_c('my-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择')
    },
    model: {
      value: _vm.formData.bill_lang_type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "bill_lang_type", $$v);
      },
      expression: "formData.bill_lang_type"
    }
  }, [_vm._l(_vm.billLangTypeEnum, function (item, index) {
    return [_c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))])];
  })], 2)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4F01\u4E1A\u5730\u5740"),
      "prop": "company_address",
      "label": _vm.t('企业地址')
    }
  }, [_c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入企业地址')
    },
    model: {
      value: _vm.formData.company_address,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "company_address", $$v);
      },
      expression: "formData.company_address"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u90AE\u7F16"),
      "prop": "postcode",
      "label": _vm.t('邮编')
    }
  }, [_c('a-input', {
    attrs: {
      "label": _vm.t('请输入邮编')
    },
    model: {
      value: _vm.formData.postcode,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "postcode", $$v);
      },
      expression: "formData.postcode"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u8425\u4E1A\u6267\u7167"),
      "prop": "business_license",
      "label": _vm.t('营业执照')
    }
  }, [_c('my-upload', {
    attrs: {
      "name": "file",
      "validate-type": "FirmAttachmentRule",
      "checkError": _vm.onCheckUploadFileError,
      "list-type": "picture-card",
      "file-list": _vm.businessLicenseList,
      "remove": _vm.onRemoveBusinessLicense,
      "before-upload": _vm.onBusinessLicenseUpload
    },
    on: {
      "onTipMessage": function ($event) {
        return _vm.handleUploadFileTipMessage('businessLicenseTip', $event);
      }
    }
  }, [!_vm.businessLicenseList.length ? _c('a-icon', {
    attrs: {
      "type": "plus"
    }
  }) : _vm._e()], 1), _c('span', {
    staticClass: "note-tip ml-10",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v(_vm._s(_vm.businessLicenseTip))])], 1), _vm._t("footer")], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };